<template>
  <va-edit-layout>
    <contacts-form :id="id" :title="title" :item="item"></contacts-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
